export default "__VITE_ASSET__86275b34__"